import { Button, Icon } from "@vp/swan";
import React, { useEffect, useState } from "react";

interface PlayPauseButtonProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
}

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({ videoRef }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  // change button icon from play to pause based on videoRef current playing status
  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  useEffect(() => {
    const videoElement = videoRef.current;

    if (videoElement) {
      const handleEnded = () => {
        setIsPlaying(false);
        videoElement.currentTime = 0;
      };

      videoElement.addEventListener("ended", handleEnded);

      // Cleanup on unmount
      return () => {
        videoElement.removeEventListener("ended", handleEnded);
      };
    }
  }, [videoRef]);

  return (
    <Button buttonShape='round' onClick={handlePlayPause}>
      {isPlaying ? (
        <Icon size='20p' iconType='pause' alt='pause' />
      ) : (
        <Icon size='20p' color='standard' iconType='play' alt='play' />
      )}
    </Button>
  );
};

export default PlayPauseButton;
